import * as _ from 'lodash';
import { requestWithToken } from '../../utilities/request';
import SessionStorageService from '../../services/utilities/SessionStorageService';
const path = '/api/private/fields';

/**
 * 不明な入退場データ一覧取得API
 * @param {string}fieldsId: 現場ID
 * @param {object}param: 検索条件
 * */
const fetchUnidentifiedLogs = (fieldsId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldsId}/unidentified_logs/list`),
    params: param,
  });
};

/**
 * 不明な入退場データ実績反映API
 * @param {string}fieldsId: 現場ID
 * @param {number}param: 不明な入退場データ一覧
 * */
const updateUnidentifiedLogs = (fieldsId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(
      `/${fieldsId}/unidentified_logs/reflect_check_in_out_logs`
    ),
    data: param,
  });
};

/**
 * 不明な入退場データ削除API
 * @param {string}fieldsId: 現場ID
 * @param {number}id 作業員ID
 * */
const deleteUnidentifiedLogs = (fieldsId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldsId}/unidentified_logs/${id}`),
  });
};

const fetchUnidentifiedLogsCSV = (fieldId, param) => {
  const searchParam = Object.create(null);
  const apiPath = path.concat(`/${fieldId}/unidentified_logs/list.csv`);
  searchParam.csv_token = SessionStorageService.getToken();
  searchParam.ccus_send_status = param.ccus_send_status;
  searchParam.prior_ccus_error_flg = param.priorCcusError
    ? data.ccusErrorPriority.ON
    : data.ccusErrorPriority.OFF;
  searchParam.record_date_from = param.record_date_from;
  searchParam.record_date_to = param.record_date_to;
  if (!_.isEmpty(param.order)) {
    searchParam.order = param.order;
  }
  return requestWithToken({
    method: 'GET',
    url: apiPath,
    params: searchParam,
    responseEncoding: 'shift-jis',
    responseType: 'blob',
  });
};

export const InOutHistoryUserUnregisteredApi = {
  fetchUnidentifiedLogs,
  updateUnidentifiedLogs,
  deleteUnidentifiedLogs,
  fetchUnidentifiedLogsCSV,
};

export default InOutHistoryUserUnregisteredApi;

const data = {
  ccusErrorPriority: {
    // CCUS送信エラーを優先して表示するフラグ
    OFF: 0,
    ON: 1,
  },
};



// WEBPACK FOOTER //
// ./src/services/inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredApi.js